import { FormNumberInputComponent } from 'src/features/generalForms/builder/types/NumberInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useCallback } from 'react';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormNumberInput: FormNumberInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback(
    (v: number) => {
      let result = props.decimal ? Number(v).toFixed(props.decimal) : v.toString();
      if (props.units) result += ` [${props.units}]`;
      return result;
    },
    [props.decimal, props.units],
  );

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <></>;
  }

  return <AnswerPreviewRow<number> value={value} isOptional={props.isOptional} renderValue={renderValue} {...props} />;
};
